import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';
import { KeyApi } from './keyapi.interface';
import { Clipboard } from '@angular/cdk/clipboard';
@Component({
  selector: 'app-keyapi',
  templateUrl: './keyapi.component.html',
  styleUrls: ['./keyapi.component.scss']
})
export class KeyapiComponent {

  constructor(private http: HttpClient,
    private alert: AlertService,
    private clipboard: Clipboard,
  ) {
    this.getKey();
  }

  keyApi: string = ""
  keyUser: string = ""
  itemKeyapi!: KeyApi[]
  getKey() {
    this.http.get(`keyapi`).subscribe({
      next: (res: any) => {
        this.itemKeyapi = res.data
      }
    })
  }

  createKey() {
    this.http.post(`key/create`, null).subscribe({
      next: (res: any) => {
        this.alert.notify(res.message, 'success')
      },
      error: (err: any) => {
        this.alert.notify(err.error.message, 'warning')
      },
      complete: () => {
        this.getKey()
      }
    })
  }

  changeKey(key: KeyApi) {
    this.alert.confirm('ถ้าคุณเปลี่ยน Key จะมีผลต่อระบบที่กำลังใช้ Key นี้อยู่จะไม่สามารถใช้งาน API ได้จนกว่าจะนำ Key ใหม่ไปเปลี่ยน คุณต้องการเปลี่ยน Key หรือไม่').then(fm => {
      if (fm.isConfirmed) this.http.put(`keyapi/update`, key).subscribe({
        next: (res: any) => {
          this.alert.notify(res.message, 'success')
        },
        error: (err: any) => {
          this.alert.notify(err.error.message, 'warning')
        },
        complete: () => {
          this.getKey()
        }
      })
    })

  }


  copyText(item: string) {
    this.clipboard.copy(item);
    this.alert.notify('Copy Text Successfull', 'success')
  }
}
